import { isDevMode } from './util';

export function cLog(msg) {
  if (isDevMode()) {
    console.log(msg);
  }
}
